import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const SeizureWarrantForm = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    gpName: '',
    warrantDate: '',
    authorizedPerson: '',
    taxpayerName: '',
    residence: '',
    amountDue: '',
    serviceFee: '',
    noteServiceDate: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-[#f4f6f9] py-5 px-2 font-sans">
      <style>
        {`
          @media print {
            @page {
              size: A4;
              margin: 10mm;
            }
            body {
              visibility: hidden;
              background: white !important;
            }
            #printable-area {
              visibility: visible;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              padding: 15mm;
              display: block !important;
              color: black !important;
            }
            .no-print {
              display: none !important;
            }
          }
        `}
      </style>

      {/* Main Form */}
      <div className="w-full bg-white border border-gray-300 shadow-sm rounded-sm overflow-x-auto no-print">
        <div className="bg-[#fff9e6] py-2 px-4 border-b border-gray-300 min-w-[1000px] flex justify-between items-center gap-2">
          <h2 className="text-[#b71c1c] text-left shrink text-[14px] sm:text-[17px] font-bold flex items-center  gap-2">
            <span className="text-blue-600 text-xl leading-none">✹</span> जप्तीचे अधिपत्र
          </h2>
          <button onClick={() => navigate(-1)} className="bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-1 px-4 rounded text-sm no-print whitespace-nowrap shrink-0">
              मागे जा
            </button>
        </div>

        <div className="p-6 min-w-[1000px]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-20 gap-y-6 mb-4">
            
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">ग्रामपंचायतीचे नाव</label>
              <select name="gpName" value={formData.gpName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm bg-white outline-none focus:border-blue-400">
                <option value="">ग्रामपंचायत निवडा</option>
                <option value="धामणी">धामणी</option>
              </select>
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">जप्तीच्या अधिपत्राची दिनांक</label>
              <input type="date" name="warrantDate" value={formData.warrantDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">अधिकृत इसमाचे नाव व पद</label>
              <input type="text" name="authorizedPerson" placeholder="नाव व पद" value={formData.authorizedPerson} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">करदात्याचे नाव</label>
              <input type="text" name="taxpayerName" placeholder="नाव" value={formData.taxpayerName} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">राहणार</label>
              <input type="text" name="residence" placeholder="पत्ता" value={formData.residence} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">येणे असलेली रक्कम रुपये</label>
              <input type="text" name="amountDue" value={formData.amountDue} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>

            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">मागणीच्या लेखाची बजावणी केल्याबद्दल फी रुपये</label>
              <input type="text" name="serviceFee" value={formData.serviceFee} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
            <div className="flex flex-col gap-1">
              <label className="text-[13px] font-bold text-[#333]">मागणीचा लेख (रिट)बजावल्याची दिनांक</label>
              <input type="date" name="noteServiceDate" value={formData.noteServiceDate} onChange={handleChange} className="border border-[#ccc] rounded-sm px-2 py-1.5 text-sm outline-none focus:border-blue-400" />
            </div>
          </div>

          <div className="mb-8 mt-2">
            <p className="text-[11px] text-red-600 leading-relaxed font-medium text-center">
              (टीप: जप्तीचे अधिपत्र काढण्यासाठी मागणीचा लेख (रिट नोटीस) बजावणी करून 30 दिवसांची मुदत संपलेली असली पाहिजे.)
            </p>
          </div>

          <div className="mt-10 flex gap-4 justify-center">
            <button onClick={handlePrint} className="bg-[#00a65a] text-white px-20 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#008d4c]">Save</button>
            <button className="bg-[#f39c12] text-white px-10 py-1.5 rounded-sm text-sm font-semibold shadow-sm hover:bg-[#e08e0b]">Generate Document</button>
          </div>

          <div className="mt-8 border border-gray-300 rounded-sm min-h-[400px] bg-white"></div>

          <div className="mt-4">
            <button className="bg-[#f4f4f4] border border-[#ddd] text-[#444] px-5 py-1.5 rounded-sm text-xs flex items-center gap-2 hover:bg-[#e8e8e8]">
              <span>🖨️</span> Print
            </button>
          </div>
        </div>
      </div>

      {/* Printable Area */}
      <div id="printable-area" className="hidden print:block font-serif text-black bg-white">
        <div className="text-center mb-10 border-b border-black pb-4">
          <h1 className="text-[22px] font-bold">ग्रामपंचायत कार्यालय: {formData.gpName}</h1>
          <p className="text-[18px] font-bold mt-1 uppercase tracking-wider">जप्तीचे अधिपत्र</p>
          <p className="text-[14px]">महाराष्ट्र ग्रामपंचायत अधिनियम १९५८ चे कलम १२९ अन्वये</p>
        </div>

        <div className="flex justify-between mb-8">
          <div>जा.क्र./ग्रा.पं./जप्ती/२०२५-२६/</div>
          <div>दिनांक: {formData.warrantDate}</div>
        </div>

        <div className="mb-8 leading-loose">
          <p>प्रति,</p>
          <p className="font-bold underline">{formData.authorizedPerson}</p>
          <p>ग्रामपंचायत {formData.gpName}</p>
        </div>

        <p className="text-[16px] leading-relaxed mb-8 text-justify">
          ज्याअर्थी, <b>{formData.taxpayerName}</b> राहणार <b>{formData.residence}</b> यांच्याकडे ग्रामपंचायतीचा येणे असलेला कर/फी रक्कम रु. <b>{formData.amountDue}</b> व नोटीस फी रु. <b>{formData.serviceFee}</b> अशी एकूण रक्कम रु. <b>{Number(formData.amountDue || 0) + Number(formData.serviceFee || 0)}</b> इतकी रक्कम थकबाकी आहे.
        </p>

        <p className="text-[16px] leading-relaxed mb-8 text-justify">
          सदर थकबाकीदारास मागणीचा लेख (रिट नोटीस) दिनांक <b>{formData.noteServiceDate}</b> रोजी बजावण्यात आला असून ३० दिवसांची मुदत संपलेली आहे. तरीही थकबाकीदाराने रक्कमेचा भरणा केलेला नाही.
        </p>

        <p className="text-[16px] leading-relaxed mb-10 text-justify">
          त्याअर्थी, आपणास या अधिपत्राद्वारे आदेश देण्यात येतो की, आपण सदर थकबाकीदाराची जंगम मालमत्ता जप्त करावी आणि त्याचा अहवाल या कार्यालयात सादर करावा.
        </p>

        <div className="flex justify-between items-end mt-24 pr-10 pl-10 font-bold text-center">
          <div></div>
          <div>
            <p>सरपंच / ग्रामसेवक / ग्रामविकास अधिकारी</p>
            <p>ग्रामपंचायत {formData.gpName}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeizureWarrantForm;
